import React from 'react';
import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <div className="disclaimer-page">
      <div className="disclaimer-container">
        <h1 className="disclaimer-title">Important Disclaimer: Please Read Carefully</h1>
        
        <section className="disclaimer-section">
          <h2>For Educational & Informational Purposes Only</h2>
          <p>
            Bitcoin Wealth Builder, and all of its associated tools, calculators, reports, and AI-generated 
            content are provided strictly for educational and informational purposes. The content generated 
            is not, and should not be considered, financial, investment, legal, tax, or any other form of 
            professional advice.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Not Financial Advice or a Recommendation</h2>
          <p>
            Nothing on this platform constitutes a solicitation, recommendation, endorsement, or offer to 
            buy or sell any securities, cryptocurrencies, or other financial instruments. The information 
            provided is impersonal and not tailored to the specific investment needs of any individual. 
            You should not rely on any information contained herein as a primary basis for any investment 
            decision.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>High-Risk Nature of Bitcoin & Digital Assets</h2>
          <p>
            Investing in Bitcoin and other digital assets is highly speculative and involves a substantial 
            degree of risk, including the risk of complete loss of capital. The market is known for extreme 
            price volatility. Past performance, whether actual or indicated by historical simulations, is 
            not a guarantee of future results.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Regarding Calculations & AI-Generated Analysis</h2>
          <p>
            The financial projections, simulations, and analyses generated by this application are based on 
            mathematical models that use historical data and a variety of assumptions. These models may not 
            account for all financial or market variables and are not predictors of future performance.
          </p>
          <p>
            The AI-Powered Analysis is generated by a Large Language Model (LLM) and should be viewed as a 
            supplementary educational tool. It is not a substitute for the judgment and expertise of a 
            qualified human financial advisor. The AI is not a fiduciary and has no knowledge of your 
            personal financial situation or risk tolerance.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>User Responsibility</h2>
          <p>
            You are solely responsible for evaluating the merits and risks associated with the use of any 
            information provided by this application before making any decisions based on such information. 
            By using this application, you agree not to hold Bitcoin Wealth Builder, its creators, or its 
            affiliates liable for any possible claim for damages arising from any decision you make based 
            on the information made available to you through this platform.
          </p>
          <p className="disclaimer-highlight">
            We strongly recommend that you seek the advice of a qualified and licensed financial advisor 
            before making any investment decisions.
          </p>
        </section>

        <div className="disclaimer-actions">
          <Link to="/" className="btn-primary">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;